import { defineMessages } from "react-intl";

const PREFIX = "Favourites.FavouritesSettings.Header";
export const messages = defineMessages({
  saveDate: {
    id: `${PREFIX}.saveDate`,
    defaultMessage: "Save date",
  },
});
